namespace Nobox {
    export interface ChatlinkcontactsRow {
        Id?: number;
        ChId?: number;
        Ch?: string;
        CtId?: number;
        Contact?: string;
        IdExt?: string;
        Extra?: string;
        Photo?: string;
        ExtId?: string;
        Username?: string;
        AccessHash?: string;
        Name?: string;
        In?: string;
        Up?: string;
        InBy?: number;
        UpBy?: number;
    }

    export namespace ChatlinkcontactsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Chat.Chatlinkcontacts';
        export const lookupKey = 'Chat.Chatlinkcontacts';

        export function getLookup(): Q.Lookup<ChatlinkcontactsRow> {
            return Q.getLookup<ChatlinkcontactsRow>('Chat.Chatlinkcontacts');
        }
        export const deletePermission = 'ChatLink:Delete';
        export const insertPermission = 'ChatLink:Modify';
        export const readPermission = 'ChatLink:View';
        export const updatePermission = 'ChatLink:Modify';

        export declare const enum Fields {
            Id = "Id",
            ChId = "ChId",
            Ch = "Ch",
            CtId = "CtId",
            Contact = "Contact",
            IdExt = "IdExt",
            Extra = "Extra",
            Photo = "Photo",
            ExtId = "ExtId",
            Username = "Username",
            AccessHash = "AccessHash",
            Name = "Name",
            In = "In",
            Up = "Up",
            InBy = "InBy",
            UpBy = "UpBy"
        }
    }
}
